import { AxiosRequestConfig } from 'axios'
import config from 'lib/config'

const formatDateElementPadding = (element: number) => element.toString().padStart(2, '0')

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getMediaHeader = (apiConfig: AxiosRequestConfig<any>) => {
    // web platform
    const platform = 1

    const version = 1

    // path
    const path = apiConfig?.url ?? ''
    const pathWithLeadingSlash = path.startsWith('/') ? path : `/${path}`
    const pathLength = (142 + pathWithLeadingSlash.length).toString().padStart(5, '0')

    // IMPORTANT: We must use server time instead of client time for API validation
    // The server validates timestamps and expects them to be within a specific time window.
    // If users have incorrect system time on their devices (common issue), API calls would fail.
    // By using server-provided timestamp, we ensure all API requests pass validation regardless
    // of the user's device time settings.
    let adjustedTimeMs = Date.now()

    // Check if server time is available in document meta tag (set during SSR)
    if (typeof window !== 'undefined' && window.document) {
        const serverTimeFromMeta = document.querySelector('meta[name="server-time"]')?.getAttribute('content')
        if (serverTimeFromMeta) {
            adjustedTimeMs = parseInt(serverTimeFromMeta)
        }
    }

    const adjustedTime = new Date(adjustedTimeMs)

    const timeFormat = [
        adjustedTime.getUTCFullYear(),
        formatDateElementPadding(adjustedTime.getUTCMonth() + 1),
        formatDateElementPadding(adjustedTime.getUTCDate()),
        formatDateElementPadding(adjustedTime.getUTCHours()),
        formatDateElementPadding(adjustedTime.getUTCMinutes()),
        formatDateElementPadding(adjustedTime.getUTCSeconds()),
    ].join('')
    const timeIdentifier = 3 * +timeFormat + 4321

    // random number
    const randomNumberMinimum = 1111
    const randomNumberMaximum = 9999
    const randomNumber = Math.floor(Math.random() * (randomNumberMaximum - randomNumberMinimum + 1)) + randomNumberMinimum

    // secret
    const secret = config.getApiSecretCode()
    const reversedSecret = secret.split('').reverse().join('')

    const header = `${platform}${version}${pathLength}${timeIdentifier}${randomNumber}${reversedSecret}`

    return header
}
